import React from 'react';
import PropTypes from 'prop-types';
import BillerVerified from './BillerVerified';
import Coverage from './Coverage';
import PcrVerified from './PcrVerified';
import BillToFacility from './BillToFacility';
import ConfirmationDialog from 'components/common/ConfirmationDialog';
import { theme } from '../../../theme';

class PatientCoverageFrame extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.facesheetAttached !== this.props.facesheetAttached) {
      this.props.validateAll(nextProps);
    }

    if (nextProps.coverageRequired !== this.props.coverageRequired) {
      this.props.validateAll(nextProps);
    }

    if (nextProps.shouldValidateAll !== this.props.shouldValidateAll && nextProps.shouldValidateAll) {
      this.props.validateAll(nextProps);
    }
    if (nextProps.triggerValidation !== this.props.triggerValidation && nextProps.triggerValidation) {
      this.props.validateAll(nextProps);
    }

    if (
      nextProps.triggerPatientValidation !== this.props.triggerPatientValidation &&
      nextProps.triggerPatientValidation
    ) {
      this.props.validateAll(nextProps);
    }

    this.props.setSaveErrorMessage(nextProps.errors);
  }

  state = {
    showBillToFacilityModal: false,
    pendingBillToFacilityEvent: null,
  };

  handleBillToFacilityChange = event => {
    if (event.target.checked) {
      this.setState({ showBillToFacilityModal: event.target.checked, pendingBillToFacilityEvent: event });
    } else {
      this.updateBillToFacility(false);
      this.props.clearPayer(window.ambulnzConfig.coordinationTypes.SUPPLEMENTAL);
      this.props.autoSavePayerInfo();
    }
  };

  handleBillToFacilityConfirmationResponse = confirmed => {
    if (confirmed) {
      this.updateBillToFacility(true);
      this.setState({
        showBillToFacilityModal: false,
        pendingBillToFacilityEvent: null,
      });
    } else {
      this.setState({
        showBillToFacilityModal: false,
        pendingBillToFacilityEvent: null,
      });
    }
  };

  updateBillToFacility = value => {
    this.props.setBilledToFacility(value);
    this.props.billedToFacilityChange(true);
  };

  render() {
    const { handleErrors } = this.props;

    const borderColor =
      this.props.isBillerVerified && this.props.isPcrVerified
        ? {
            borderTop: '#33cc99 2px solid',
            borderRight: '#33cc99 2px solid',
            borderLeft: '#33cc99 2px solid',
            padding: '0 10px',
          }
        : {
            borderTop: '2px solid #ff5252',
            borderRight: '2px solid #ff5252',
            borderLeft: '2px solid #ff5252',
            padding: '0 10px',
          };

    const containerStyle = {
      position: 'relative',
      margin: '30px -10px -10px -10px',
      padding: '0 12px',
    };

    const dialogTitleStyles = {
      fontSize: 20,
      fontWeight: 600,
      textAlign: 'left',
    };

    const getContainerStyle = () => {
      if (this.props.loadedRequest && this.props.coverageRequired) {
        return {
          ...containerStyle,
          ...borderColor,
        };
      }
      return containerStyle;
    };

    return (
      <div style={getContainerStyle()}>
        {this.props.isBillToFacilityVisible && (
          <BillToFacility {...this.props} onBillToFacilityToggle={this.handleBillToFacilityChange} />
        )}
        <ConfirmationDialog
          open={this.state.showBillToFacilityModal}
          onClose={this.handleBillToFacilityConfirmationResponse}
          cancel={this.handleBillToFacilityConfirmationResponse}
          titlestyles={dialogTitleStyles}
          okButtonStyle={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.secondary.contrastText,
            fontSize: 16,
          }}
          cancelButtonStyle={{
            fontSize: 16,
          }}
          title="Bill To Facility?"
          cancelText="CANCEL"
          okText="CONFIRM"
        >
          <div style={{ fontSize: 16, paddingTop: 10, paddingBottom: 10 }}>
            Are you sure you want to bill to facility? This will replace the supplemental insurance field.
          </div>
        </ConfirmationDialog>
        {this.props.coordinationTypes.map((type, i) => (
          <Coverage
            key={type.id}
            inputId={type.name}
            shouldValidateAll={this.props.shouldValidateAll}
            disabled={this.props.disabled || null}
            handleErrors={handleErrors}
            insuranceName={type.displayName}
            coordinationTypeId={type.id}
            swapWithCoordinationType={this.props.coordinationTypes[i + 1]}
            isRequired={!this.props.isBilledToFacility && i === 0}
            isLineHidden={!this.props.isBillToFacilityVisible && i === 0}
            first={i === 0}
            reorder={i !== this.props.coordinationTypes.length - 1}
            coverageRequired={!this.props.isBilledToFacility && this.props.coverageRequired}
          />
        ))}

        {this.props.user.isDispatcher && (
          <>
            <BillerVerified />
            <PcrVerified
              isPcrEnabled={this.props.isPcrVerificationEnabled}
              isBillerVerified={this.props.isBillerVerified}
              isPcrVerified={this.props.isPcrVerified}
            />
          </>
        )}
      </div>
    );
  }
}

PatientCoverageFrame.propTypes = {
  errors: PropTypes.shape().isRequired,
  handleErrors: PropTypes.func.isRequired,
  isBillerVerified: PropTypes.bool.isRequired,
  loadedRequest: PropTypes.bool.isRequired,
  shouldValidateAll: PropTypes.bool.isRequired,
  triggerValidation: PropTypes.bool.isRequired,
  triggerPatientValidation: PropTypes.bool.isRequired,
  user: PropTypes.shape().isRequired,
  validateAll: PropTypes.func.isRequired,
  facesheetAttached: PropTypes.bool.isRequired,
  coverageRequired: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default PatientCoverageFrame;
